/**
 * Utility function to standardize Boolean values from various formats
 * Handles string values like: '0', '1', 'TRUE', 'FALSE', 'True', 'False', 'true', 'false'
 * @param value - The string value to convert to a standard Boolean
 * @returns A standardized Boolean value (true/false)
 */
function formatBooleanValue(value: string): boolean {
  const normalizedValue = value.trim().toLowerCase();

  if (normalizedValue === '1' || normalizedValue === 'true') {
    return true;
  }

  return false;
}

/**
 * Formats a boolean string value as a user-friendly display string
 * @param value - The string value to format
 * @returns A formatted string ('True' or 'False')
 */
function formatBooleanForDisplay(value: string): string {
  const boolValue = formatBooleanValue(value);
  return boolValue ? 'True' : 'False';
}

export { formatBooleanValue, formatBooleanForDisplay };
